<div class="route-planner-print-model">
  <div class="header">
    <div class="app-header-content">
      <a class="app-header-logo" href="https://www.theaa.com/"></a>
      <h1>Route Planner</h1>
    </div>

    <aa-app-advertisement type="the-aa-leaderboard-2"></aa-app-advertisement>
  </div>

  <!-- Toolbar -->
  <table class="table toolbar">
    <thead>
      <tr>
        <th scope="col">
          <div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
            <button type="button" class="btn btn-secondary" (click)="updateMapSetting('map-none')">Hide Map</button>
            <button type="button" class="btn btn-secondary" (click)="updateMapSetting('map-small')">Small Map</button>
            <button type="button" class="btn btn-secondary" (click)="updateMapSetting('map-large')">Large Map</button>
          </div>
        </th>
        <th scope="col">
          <button class="btn print-btn float-right" (click)="printMap()">
            <span>Print</span>
            @if (mapSettings.preparing) {
              <output class="spinner-border"></output>
            }
          </button>

          <div class="form-check form-check-inline float-right">
            <label class="checkbox">
              <input
                type="checkbox"
                [(ngModel)]="hideSignPostsModel"
                (ngModelChange)="onSignPostChange(hideSignPostsModel)"
                />
                <span class="tick"></span><span class="label">Hide roadsigns</span>
              </label>
            </div>
          </th>
        </tr>
      </thead>
    </table>

    <!-- google map -->
    <div class="map">
      <aa-hybrid-google-map
        [mapType]="mapType"
        class="google-map-print-main"
        [data]="getMapData()"
        [mapStyle]="mapSettings.type"
        >
      </aa-hybrid-google-map>
    </div>

    <!-- From & To Direction -->
    <div class="from-to-location">
      <table class="table table-sm">
        <tbody>
          <tr>
            <th>
              <div>
                <strong>From:</strong>
                <img src="./assets/images/location-icon.jpg" alt="from location" class="logo" />
                <span [innerHTML]="routeDataModel.FromLocation.Name"></span>
              </div>
              @for (location of this.routeDataModel.ViaRoutes; track trackByFn($index)) {
                <div class="via-location">
                  <strong>Via</strong>
                  <img src="./assets/images/location-icon.jpg" alt="via location" class="logo" />
                  <span [innerHTML]="location.Name"></span>
                </div>
              }
              <div>
                <strong>To:</strong>
                <img src="./assets/images/location-icon.jpg" alt="to location" class="logo" />
                <span [innerHTML]="routeDataModel.ToLocation.Name"></span>
              </div>
            </th>
            <th><div></div></th>
            <th class="distance">
              @if (selectedSummaryData) {
                <div><strong>Distance: </strong>{{ selectedSummaryData.formatDistance }}</div>
              }
              @if (selectedSummaryData) {
                <div><strong>Time:</strong>{{ selectedSummaryData.formatDuration }}</div>
              }
            </th>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Direction -->
    <div>
      <table class="table table-hover">
        <thead>
          <tr>
            <td>Distance</td>
            <td>Directions</td>
            <td>Total</td>
            <td></td>
          </tr>
        </thead>

        @for (routeSignpost of routeSignpostList.RouteSignpost; track trackByFn(rootIndex); let rootIndex = $index) {
          <tbody>
            <tr>
              <td class="distance"><strong>Start: </strong></td>
              <td class="instructions">{{ routeSignpost.StartRouteLeg.Summary }}</td>
              <td></td>
              <td></td>
            </tr>
            @for (direction of routeSignpost.RouteLegs; track trackByFn(idx); let idx = $index) {
              <tr>
                <td [innerHTML]="direction.formatedDistanceValue"></td>
                <td>
                  <div [innerHTML]="direction.Summary"></div>
                  @if (!hideSignPosts) {
                    <aa-aa-signpost-list [direction]="direction"></aa-aa-signpost-list>
                  }
                @if (direction.showGoogleMap) {
                    <aa-hybrid-google-map
                      class="printConfig"
                      [mapType]="1000 + rootIndex * 1000 + idx"
                      [data]="getMapDataForDirection(direction)"
                    ></aa-hybrid-google-map>
                }
              </td>
              <td [innerHTML]="direction.Distance"></td>
              <td>
                <a (click)="toggleMap(direction)" (keyup.enter)="toggleMap(direction)" tabindex="0" class="toggle-map-link">
                  @if (!direction.showGoogleMap) {
                    <span>Show map</span>
                  }
                  @if (direction.showGoogleMap) {
                    <span>Hide map</span>
                  }
                </a>
              </td>
            </tr>
          }
          <tr class="direction-item">
            <td class="distance">{{ routeSignpost.EndRouteLeg.formatedDistanceValue }}</td>
            <td class="instructions"><strong>Arrive: </strong>{{ routeSignpost.EndRouteLeg.Summary }}</td>
            <td>{{ routeSignpost.EndRouteLeg.Distance }}</td>
            <td></td>
          </tr>
          <tr class="direction-item section">
            <td class="distance"></td>
            <td class="instructions" [innerHTML]="routeSignpost.durationToPrint()"></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      }
    </table>
  </div>

  <div class="footer">
    <p>
      AA Roadwatch | Call 84322 on your mobile to get the latest traffic and weather news | Calls from mobiles are
      charged at variable rates up to 65p per minute
    </p>
    <p>
      These directions are subject to the AA Travel Terms & Conditions and are for informational purposes only.
      Construction projects, traffic or other events may cause actual conditions to differ from these results. No
      guarantee is made regarding their completeness or accuracy. If you spot a mistake or something missing, please
      e-mail: routeplannerfeedback&#64;theaa.com
    </p>
    <p>© Automobile Association Developments Ltd. 2019</p>
  </div>
</div>
